import { ethers } from 'ethers';
import {
    convertBigToSmallDigitWithSpecificDecimal,
    convertInTokenBigAmount,
} from './commonFunction';

export function getTokenEntryFromList(tokenList, tokenAddress) {
    if (!tokenAddress || !Array.isArray(tokenList)) return null;
    const needle = String(tokenAddress).toLowerCase();
    return (
        tokenList.find(
            (token) => String(token.address || '').toLowerCase() === needle,
        ) ?? null
    );
}

export function normalizeTokenBalance(balance) {
    if (typeof balance === 'bigint') return balance;
    if (balance === null || balance === undefined) return 0n;
    try {
        return ethers.toBigInt(balance);
    } catch {
        return 0n;
    }
}

/**
 * @returns {{ sufficient: boolean, reason: string|null, balance: bigint, required: bigint, balanceFormatted: string, requiredFormatted: string }}
 */
export function assessPaymentRequestBalance({
    tokenList,
    tokenAddress,
    parsedNumber,
    tokenDecimal,
}) {
    const required = convertInTokenBigAmount(parsedNumber, tokenDecimal);
    const requiredFormatted = convertBigToSmallDigitWithSpecificDecimal(
        required,
        tokenDecimal,
    );
    const entry = getTokenEntryFromList(tokenList, tokenAddress);

    if (!entry) {
        return {
            sufficient: false,
            reason: 'unknown_token',
            balance: 0n,
            required,
            balanceFormatted: '0',
            requiredFormatted,
        };
    }

    const balance = normalizeTokenBalance(entry.balance);
    const balanceFormatted = convertBigToSmallDigitWithSpecificDecimal(
        balance,
        tokenDecimal,
    );
    const sufficient = balance >= required;

    return {
        sufficient,
        reason: sufficient ? null : 'insufficient',
        balance,
        required,
        balanceFormatted,
        requiredFormatted,
    };
}

export function formatInsufficientBalanceMessage(
    tokenName,
    balanceFormatted,
    requiredFormatted,
) {
    return `Insufficient ${tokenName || 'token'} balance. You have ${balanceFormatted} but this request requires ${requiredFormatted}.`;
}
